// extracted by mini-css-extract-plugin
export default {"container":"AnswerEmail_container__oEiFI","title":"AnswerEmail_title__rKl15","text":"AnswerEmail_text__5YCdq"};